<template lang="pug">
div.tree-view(:key="currentNode.id")

    div.select-all-cartridge(v-if="isCcloneFirstParty && showSelectAll && nodeType != 'customTaxonomies'")
        label.label.flex-1(for="selectAllFirstParty") Select all
        input(
            v-model="selectAllFirstParty"
            id="selectAllFirstParty"
            name="selectAllFirstParty"
            @change="selectAll"
            type="checkbox")

    div.tree-item(v-for="(node, nKey) in cmpNodes" :key="nKey" :class="{'ui-disabled': disableCustomTaxoHierarchy(node.id, node.parentJsonKeyName)}")

        div.tree-node(
            :class="[{'tree-node__tp': showId(node) || hasSmartSegments(node)}, {'tree-node__btm': hasTags(node)}]"
            @click.stop="selectNode(node, { selectChildren: false })")
            label.label_invisible(
                v-if="isCclone"
                :for="node.jsonKey.name"
            )


            div.node-icon
                div.node-icon__default(v-if="!node.hasChild")
                svg-icon(
                    v-else
                    name='folder' size="small"
                    :class="isNodeExpanded(node.jsonKey.name) ? 'node-icon__open' : 'node-icon__close'"
                    @click.native.stop="expandNode(node.jsonKey.name, !isNodeExpanded(node.jsonKey.name))")

            div.tree-node__info(v-if="!isCclone || (isCclone && node.isSelectable)")
                div.l-flex-row.tree-node__top-info(v-if="showId(node) || hasSmartSegments(node)")
                    div.tree-node__id(v-if="showId(node)") {{ criterionId(node) }}
                    svg-icon.tree-node__smartsegment(v-if="!isCclone && hasSmartSegments(node) && showFrequency && nodeSubType !== 'sharing'" name='period' size='small')


                label.tree-node__label(
                    v-if="isCclone"
                    :title="node.label"
                ) {{ node.label }}

                div.tree-node__label(
                    v-else
                    :title="node.label"
                ) {{ node.label }}

                div.tree-node__btm-info(v-if="!isCclone && hasTags(node)")
                    //- Tags
                    div.criterion-taglist
                        span.criterion-tag(
                            v-for="(tag, index) of node.tags" :key="tag.id" v-if="index < 3 || displayAllTags(node.jsonKey.name)"
                            @click.stop="launchSearch(tag.label)")
                            span.tag-label(:title="tag.label") {{ tag.label }}
                        template(v-if="node.tags.length > 3")
                            button.btn-toogle-tag.btn-nude(
                                v-if="displayAllTags(node.jsonKey.name)"
                                @click.stop="toggleFullList(node.jsonKey.name, false)") less
                            button.btn-toogle-tag.btn-nude(
                                v-else
                                @click.stop="toggleFullList(node.jsonKey.name, true)") more

            div.tree-node__info(v-else)
                div.l-flex-row.tree-node__top-info(v-if="showId(node) || hasSmartSegments(node)")
                    div.tree-node__id(v-if="showId(node)") {{ criterionId(node) }}
                    svg-icon.tree-node__smartsegment(v-if="!isCclone && hasSmartSegments(node) && showFrequency" name='period' size='small')
                div.tree-node__label(:title="node.label" @click.stop="openNode(node)") {{ node.label }}

            div.tree-node__action(
                v-if="node.hasChild && isHierarchy && !isCclone"
                @click.stop="selectNode(node, { selectChildren: true })")
                svg-icon(name='drop-children' size="medium")

            div.tree-node__action(v-else-if="node.isSelectable && isCcloneEvent")
                input.form-input(
                    v-model="ccloneEventSelectedCriterion"
                    :id="node.jsonKey.name"
                    :name="node.jsonKey.name"
                    :value="node"
                    type="radio")

            div.tree-node__action.l-flex-row.l-align-center(v-else-if="nodeType === 'audience'")
                div(@click.stop="setSwitchToAudience(node)" :title="node.type === 'cclones' ? 'This audience can not be edited' : 'Edit this audience'")
                    div.tree-node__action(
                        :disabled="node.type === 'cclones'"
                    )
                        svg-icon(name='edit' size="medium")

                div.tree-node__action(
                    title="Add audience to formula"
                    @click.stop="selectNode(node, { selectChildren: false })")
                    svg-icon(name="shareFromSquare" size="large")

            div.tree-node__action.visible(v-else-if="node.isSelectable && isCcloneFirstParty")
                input.form-input(
                    v-model="ccloneFirstPartySelectedCriteria"
                    :id="node.jsonKey.name"
                    :name="node.jsonKey.name"
                    :value="node.jsonKey.name"
                    @change="selectNode(node, { selectChildren: false })"
                    type="checkbox")

        transition(name="slide-fade")
            Tree(
                v-if="isNodeExpanded(node.jsonKey.name)"
                :key="node.jsonKey.name"
                :nodes="childrenNodeTree(node.jsonKey.name)"
                :nodeType="nodeType"
                :nodeSubType="nodeSubType"
                :isCcloneEvent="isCcloneEvent"
                :isCcloneFirstParty="isCcloneFirstParty"
                :firstPartySelection="firstPartySelection"
                :ccloneHistory="ccloneHistory"
                :storeFirstPartySelectAll="storeFirstPartySelectAll"
                class="children-node"
            )
</template>

<script>
import { MEDIA_CONVERSION_TYPE, MEDIA_CAMPAIGN_TYPE } from '@/utils/constants'
//avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

import { cloneDeep, find, head, includes, intersection, isEmpty, isEqual, isNil, keys, last, map, size, get } from 'lodash'

export default {
    name: 'Tree',

    props: {
        ccloneHistory: { type: Object, required: false, default: () => ({}) },
        firstPartySelection: { type: Array, required: false, default: () => [] },
        isCcloneEvent: { type: Boolean, required: false },
        isCcloneFirstParty: { type: Boolean, required: false },
        nodeType: { type: String, required: true },
        nodeSubType: { type: String, required: false, default: '' },
        nodes: { type: Array, required: true },
        showSelectAll: { type: Boolean, required: false },
        storeFirstPartySelectAll: { type: Object, required: false, default: () => ({}) },
        launchSearch: { type: Function, required: false, default: () => ({}) },
        areFoldedNodes: { type: Boolean, required: false }
    },

    watch: {
        ccloneEventSelectedCriterion: {
            handler: function(newValue) {
                if (!isEqual(newValue.id, false) && this.eventType === 'positive') {
                    this.setSelectedEvent({ eventType: this.eventType, event: newValue })
                }
                if (this.eventType === 'negative') {
                    if (!isEqual(newValue.id, false) && !isEqual(newValue, this.negativeEvent)) {
                        this.setSelectedEvent({ eventType: this.eventType, event: newValue })
                    }
                }
            }
        },
        negativeEvent: {
            handler: function(newValue, oldValue) {
                if (!isEqual(oldValue, newValue) && !isEqual(newValue, this.ccloneEventSelectedCriterion)) {
                    this.ccloneEventSelectedCriterion = { id: false }
                }
            }
        },
        positiveEvent: {
            handler: function(newValue, oldValue) {
                if (!isEqual(oldValue, newValue) && !isEqual(newValue, this.ccloneEventSelectedCriterion)) {
                    this.ccloneEventSelectedCriterion = { id: false }
                }
            }
        },
        ccloneFirstPartySelectedCriteria: {
            handler: function(newValue, oldValue) {
                if (!isEqual(oldValue, newValue)) {
                    const action = size(newValue) > size(oldValue) ? 'add' : 'remove'

                    if (!isNil(this.currentFirstPartyNode)) {
                        this.selectChildren({ action, category: this.nodeType, item: this.currentFirstPartyNode })
                    }
                    this.currentFirstPartyNode = null
                }
            },
        },
        firstPartySelection: {
            handler: function(newValue, oldValue) {
                if (!isEqual(oldValue, newValue)) {
                    this.ccloneFirstPartySelectedCriteria = intersection(newValue, map(this.cmpNodes, 'jsonKey.name'))
                }
                if (this.isCcloneFirstParty && this.showSelectAll) {
                    const _keys = keys(this.storeFirstPartySelectAll)
                    if (includes(_keys, this.nodeType)) {
                        let list = []
                        if (this.nodeType === 'hierarchy') list = this.getCurrentTaxonomyHierarchy()
                        else list = this.$store.state.data[this.nodeType].list
                        const selectedItemsAndSlectedChildren = intersection(newValue, map(list, 'jsonKey.name'))
                        if (isEqual(size(selectedItemsAndSlectedChildren), size(list))) {
                            this.selectAllFirstParty = true
                            this.setFirstPartySelectAll({ mediaType: this.nodeType, isSelecting: true })
                        } else {
                            this.selectAllFirstParty = false
                            this.setFirstPartySelectAll({ mediaType: this.nodeType, isSelecting: false })
                        }
                    }
                }
            },
            deep: true,
            immediate: true
        },
        areFoldedNodes: {
            handler: function(newValue) {
                if (newValue) {
                    this.resetExpandedNodesIds()
                }
            }
        },
        nodes: {
            handler: function(newValue) {
                this.cmpNodes = cloneDeep(newValue)
            }
        },
        isEditingAudience: {
            handler: function(newValue, oldValue) {
                if (newValue && !oldValue && !isEmpty(this.audienceInEdition) && this.getIsFormulaEmpty()) {
                    this.addAudienceFormulaForEdition(this.audienceInEdition)
                } else if (!newValue) {
                    this.hasDisplayedFeatureDisabledMessage = false
                }
            }
        }
    },

    data() {
        //automatically expand node ONLY when is the only node AND it's first parent
        const nodes = cloneDeep(this.nodes)
        const firstNode = head(nodes)
        if (!this.isCcloneEvent && !this.isCcloneFirstParty && size(nodes) === 1 && isNil(firstNode.parentJsonKeyName) && firstNode.hasChild) {
            this.setExpandedNodesIds({ id: firstNode.jsonKey.name, action: 'expand' })
        } else if (this.isCcloneEvent) {
            for (const node of nodes) {
                if (node.hasChild) {
                    this.setExpandedNodesIds({ id: node.jsonKey.name, action: 'collapse' })
                }
            }
        } else if (this.isCcloneFirstParty) {
            for (const node of nodes) {
                if (node.hasChild) {
                    this.setExpandedNodesIds({ id: node.jsonKey.name, action: 'expand' })
                }
            }
        }

        const selectAllKeys = keys(this.storeFirstPartySelectAll)
        const _selectAllFirstParty = isEmpty(selectAllKeys) || !includes(selectAllKeys, this.nodeType) ? false : this.storeFirstPartySelectAll[this.nodeType]

        return {
            displayIds: ['media', 'hierarchy', 'audience', 'georadar', 'sharedAudiences'],
            ccloneEventSelectedCriterion: isNil(this.ccloneHistory) ? { id: false } : this.ccloneHistory,
            ccloneFirstPartySelectedCriteria: isEmpty(this.firstPartySelection) ? [] : intersection(this.firstPartySelection, map(nodes, 'jsonKey.name')),
            currentFirstPartyNode: null,
            selectedCriterion: isNil(this.ccloneHistory) ? { id: false } : this.ccloneHistory,
            cmpNodes: cloneDeep(nodes),
            selectAllFirstParty: _selectAllFirstParty,

            // data used as keys to trigger re-render on nodeExpand
            currentNode: { id: 0 },
            expandedCriteria: {},
            hasDisplayedFeatureDisabledMessage: false
        }
    },

    computed: {
        // Call to getters
        ...mapGetters('ui/builder', ['getTreeNode', 'getSearchResults', 'getFormulaCriterionToBuilderFormat', 'getIsFormulaEmpty']),
        ...mapState('data/settings', {
            showFrequency: state => state.general.frequency
        }),
        ...mapGetters('data/customTaxonomies', ['getCurrentTaxonomyHierarchy']),
        ...mapState('ui/builder', {
            expandedNodesIds: state => state.expandedNodesIds,
            focusedBox: state => state.focusedBox,
            isEditingAudience: state => state.isEditingAudience,
            audienceInEdition: state => state.audienceInEdition,
            boxFormula: state => state.formula
        }),
        ...mapState('data/customTaxonomies', {
            hierarchies: state => state.hierarchies
        }),
        ...mapState('ui/cclone', {
            ccloneCriteriaTypes: state => state.criteriaTypes,
            eventType: state => state.eventType,
            negativeEvent: state => state.selectedEvents.negative,
            positiveEvent: state => state.selectedEvents.positive
        }),
        isCclone() {
            return this.isCcloneEvent || this.isCcloneFirstParty
        },
        isCustomTaxo() {
            return this.nodeType === 'customTaxonomies'
        },
        isSharedTaxo() {
            return this.nodeType === 'taxonomies'
        },
        isTaxo() {
            return this.isCustomTaxo || this.isSharedTaxo
        },
        isHierarchy() {
            return this.nodeType === 'hierarchy'
        }
    },

    mounted() {
        this.initSelectedAll()
    },

    methods: {
        // Call to actions
        ...mapActions('ui/builder', ['addCriterionInBox']),
        ...mapActions('ui/manageTaxonomy', ['retrieveHierarchyOfSelectedTaxonomy']),
        ...mapActions('ui/cclone', ['selectChildren']),
        ...mapActions('data/customTaxonomies', ['retrieveItems']),
        ...mapActions('data/taxonomies', ['getTaxonomySegments']),
        ...mapMutations('ui/builder', [
            'setExpandedNodesIds',
            'setDisabledFormulaBox',
            'resetExpandedNodesIds',
            'setCriterion',
            'setIsEditingAudience',
            'setNewBoxInFormula',
            'setDeletedBox',
            'setDisplayModal',
            'setAudienceInEdtion',
            'setNextAudienceInEdtion',
            'setEmptyFormula'
        ]),
        ...mapMutations('ui/cclone', ['setFirstPartySelectAll', 'setSelectedEvent', 'setCriteriaType']),
        ...mapMutations('data/customTaxonomies', ['setSelectedCustomTaxonomy']),
        ...mapMutations('data/taxonomies', ['setSelectedSharedTaxonomie']),
        ...mapMutations('notifications', ['setAddedNotification']),

        childrenNodeTree(jsonKeyName) {
            const criterion = this.isCcloneEvent ? this.ccloneCriteriaTypes[this.eventType].current : null
            return isNil(jsonKeyName) ? null : this.getTreeNode({ jsonKeyName, criterion, criterionSubType: this.nodeSubType })
        },
        isNodeExpanded(nodeJsonKeyName) {
            if (this.areFoldedNodes) {
                return false
            }
            return !!find(this.expandedNodesIds, nodeId => nodeId === nodeJsonKeyName)
        },
        expandNode(nodeJsonKeyName, shouldExpand) {
            this.$emit('foldNodes')
            this.currentNode = { id: nodeJsonKeyName }

            this.setExpandedNodesIds({ id: nodeJsonKeyName, action: shouldExpand ? 'expand' : 'collapse' })
        },
        addCriterionToFormula(criterion, { selectChildren }) {
            let nodeType

            if (criterion.isSelectable) {
                if (selectChildren) {
                    nodeType = 'children'
                } else {
                    nodeType = 'self'
                }
                this.setDisabledFormulaBox({ boxIndex: this.focusedBox.index, boxType: this.focusedBox.type, isDisabled: false })
                this.addCriterionInBox({
                    criterion: criterion,
                    nodeType,
                    criterionSubType: this.nodeSubType
                })
            } else if (criterion.hasChild) {
                this.expandNode(criterion.jsonKey.name, !this.isNodeExpanded(criterion.jsonKey.name))
            }
        },
        selectNode(criterion, { selectChildren }) {
            if (!this.isCclone && !this.isTaxo) {
                this.addCriterionToFormula(criterion, { selectChildren })
            } else if (this.isCcloneFirstParty && !this.isTaxo) {
                this.currentFirstPartyNode = criterion
            } else if (this.isCustomTaxo) {
                const isTaxoInStore = this.hierarchies[criterion.id]
                if (isNil(isTaxoInStore)) {
                    this.retrieveItems({ taxoId: criterion.id }).then(() => {
                        this.setCriterion({ type: 'hierarchy', name: criterion.label })
                        if (this.isCcloneEvent) this.setCriteriaType({ eventType: this.eventType, criteriaType: 'hierarchy', history: 'current' })
                    })
                } else {
                    this.setSelectedCustomTaxonomy({ id: criterion.id })
                    this.setCriterion({ type: 'hierarchy', name: criterion.label })
                    if (this.isCcloneEvent) this.setCriteriaType({ eventType: this.eventType, criteriaType: 'hierarchy', history: 'current' })
                }
            } else if (this.isSharedTaxo) {
                if (isEmpty(criterion.segments)) {
                    this.getTaxonomySegments({ taxonomyId: criterion.id, source: 'shared' }).then(() => {
                        this.setCriterion({ type: 'hierarchy', name: criterion.label })
                        this.setSelectedSharedTaxonomie({ taxonomyId: criterion.id })
                    })
                } else {
                    this.setCriterion({ type: 'hierarchy', name: criterion.label })
                    this.setSelectedSharedTaxonomie({ taxonomyId: criterion.id })
                }
            }
        },
        openNode(criterion) {
            if (this.isCustomTaxo) {
                this.retrieveItems({ taxoId: criterion.id }).then(() => {
                    this.setCriterion({ type: 'hierarchy', name: criterion.label })
                    if (this.isCcloneEvent) this.setCriteriaType({ eventType: this.eventType, criteriaType: 'hierarchy', history: 'current' })
                })
            } else if (this.isSharedTaxo) {
                this.getTaxonomySegments({ taxonomyId: criterion.id, source: 'shared' }).then(() => {
                    this.setCriterion({ type: 'hierarchy', name: criterion.label })
                    if (this.isCcloneEvent) {
                        this.setCriteriaType({ eventType: this.eventType, criteriaType: 'hierarchy', history: 'current' })
                        this.setSelectedSharedTaxonomie({ taxonomyId: criterion.id })
                    }
                })
            }
        },
        hasTags(criterion) {
            return !isEmpty(criterion.tags)
        },
        hasSmartSegments(criterion) {
            return !isEmpty(criterion.smartSegmentIds)
        },
        showId(criterion) {
            const restrictedTypes = ['Campaign', 'Conversion']
            const restrictedSubTypes = ['media_media_campain_clicked', 'media_media_campain_exposed']
            return includes(restrictedTypes, criterion.jsonKey.type) || includes(restrictedSubTypes, criterion.jsonKey.subType)
                ? false
                : !isNil(find(this.displayIds, id => id === this.nodeType))
        },
        criterionId(criterion) {
            const restrictedSubtype = ['media_media_campain_clicked', 'media_media_campain_exposed']
            if (includes(MEDIA_CONVERSION_TYPE, criterion.jsonKey.type)) return last(criterion.id)
            else if (includes(MEDIA_CAMPAIGN_TYPE, criterion.jsonKey.type)) {
                if (includes(restrictedSubtype, criterion.jsonKey.subType)) return null
                return criterion.jsonKey.subType === 'project_campaign' ? last(criterion.id) : head(criterion.id)
            }
            return criterion.id
        },
        selectAll() {
            const action = this.selectAllFirstParty ? 'add' : 'remove'
            this.setFirstPartySelectAll({ mediaType: this.nodeType, isSelecting: this.selectAllFirstParty })
            this.selectChildren({ action, category: this.nodeType, item: null })
        },
        toggleFullList(nodeId, status) {
            if (status) {
                this.expandedCriteria = {
                    ...this.expandedCriteria,
                    [nodeId]: true
                }
            } else {
                this.expandedCriteria = {
                    ...this.expandedCriteria,
                    [nodeId]: false
                }
            }
        },
        displayAllTags(nodeId) {
            const _areCriterionTagsAllDisplayed = get(this.expandedCriteria, `${nodeId}`, null)
            return _areCriterionTagsAllDisplayed
        },

        /**
         * Deactivates the hierarchies that have not yet been retrieved regarding their id and parentJsonKeyName
         * only nodes with type 'customTaxonomies' and no parent can be deactivated
         * @param {String | Number} id id of the custom taxonomy
         * @param {String} parentJsonKeyName JsonKeyname of the node parent
         * @returns {Booolean} should the item be deactivated or not
         */
        disableCustomTaxoHierarchy(id, parentJsonKeyName) {
            if (
                this.nodeType === 'customTaxonomies'
                && isEmpty(this.hierarchies[id])
                && isNil(parentJsonKeyName)
            ) {
                return true
            }
            return false
        },

        addAudienceFormulaForEdition(node) {
            const audience = cloneDeep(node)
            let deletedCriterias = 0
            let activeCriterias = 0

            const formatCriterion = criteria => {
                activeCriterias++
                const formatedCriteria = this.getFormulaCriterionToBuilderFormat(criteria)
                if (formatedCriteria.hasDisabledFeature) {
                    this.checkHascriterionDisabledFeature()
                    delete criteria.hasDisabledFeature
                }
                if (formatedCriteria === 'deleted') deletedCriterias++
                else this.selectNode(formatedCriteria, { selectChildren: false })
            }

            // Case 1: Only 1 criterion in an union box
            if (!Array.isArray(audience.formula)) {
                formatCriterion(audience.formula)
            }
            // Case 2: Several criterion in an union box or exclusion box
            else if (audience.formula[0] === '|' || audience.formula[0] === '!') {
                if (audience.formula[0] === '!') {
                    // Add the exclusion box, remove the first union box
                    this.setNewBoxInFormula({ boxType: 'exclusion' })
                    this.setDeletedBox({ boxIndex: 0, boxType: 'inclusion' })
                }
                audience.formula.shift()
                audience.formula.forEach(criteria => {
                    formatCriterion(criteria)
                })
            }
            // Case 3: Several boxes, can be a mix of union and exclusion boxes
            else if (audience.formula[0] === '&') {
                audience.formula.shift()
                for (const box of audience.formula) {
                    if (box[0] === '!') this.setNewBoxInFormula({ boxType: 'exclusion' })
                    else this.setNewBoxInFormula({ boxType: 'inclusion' })

                    if (Array.isArray(box)) {
                        box.shift()
                        box.forEach(criteria => {
                            formatCriterion(criteria)
                        })
                    } else formatCriterion(box)
                }
                this.setDeletedBox({ boxIndex: 0, boxType: 'inclusion' })
            }

            // Case where there is some deleted criterias but some active
            if (deletedCriterias > 0 && deletedCriterias < activeCriterias) {
                this.setAddedNotification({ type: 'success', message: 'Some of your audience criterias were deleted' })
            }
            // Case where there is only deleted criterias
            else if (deletedCriterias === activeCriterias) {
                this.setEmptyFormula()
                this.setDisplayModal({ item: 'formulaHasOnlyDeletedCriteria', display: true })
                this.$nextTick(() => {
                    this.setNewBoxInFormula({ boxType: 'inclusion' })
                })
            }
            this.cleanEmptyBoxes()
        },

        setSwitchToAudience(node) {
            // Workaround to avoid issue with disable triggering global component methodd
            if (node.type === 'cclones') return

            if (this.getIsFormulaEmpty()) {
                this.setAudienceInEdtion({ node })
                this.setIsEditingAudience({ isEditing: true })
                this.addAudienceFormulaForEdition(node)
            } else {
                this.setNextAudienceInEdtion(node)
                this.setDisplayModal({ item: 'formulaIsNotEmpty', display: true })
            }
        },

        cleanEmptyBoxes() {
            // Delete unused boxes
            for (const [idx, val] of this.boxFormula.inclusion.entries()) {
                if (val.criteria.length === 0) this.setDeletedBox({ boxIndex: idx, boxType: 'inclusion' })
            }
            for (const [idx, val] of this.boxFormula.exclusion.entries()) {
                if (val.criteria.length === 0) this.setDeletedBox({ boxIndex: idx, boxType: 'exclusion' })
            }
        },

        checkHascriterionDisabledFeature() {
            if (!this.hasDisplayedFeatureDisabledMessage) {
                this.hasDisplayedFeatureDisabledMessage = true
                this.setAddedNotification({
                    type: 'success',
                    message: 'The formula of the audience has been altered because some data or feature are unavailable.'
                })
            }
        },

        initSelectedAll() {
            if(this.isCcloneFirstParty && this.showSelectAll && this.nodeType != 'customTaxonomies') {
                if(
                    !isEmpty(this.firstPartySelection)
                    && !isEmpty(this.$store.state.data[this.nodeType].list)
                ){
                    const nodeTypeList = this.$store.state.data[this.nodeType].list
                    const checkeds = [...this.firstPartySelection.filter((checked) => {
                        const findNodeType = nodeTypeList.find((type) => checked === type.jsonKey.name)
                        return findNodeType
                    })]
                    if(size(nodeTypeList) === size(checkeds)) {
                        this.selectAllFirstParty = true
                    } else{
                        this.selectAllFirstParty = false
                    }
                }
            }
        }
    }
}
</script>
